import { SyncOutlined } from "@ant-design/icons"
export const TableLoader={ 
    indicator: <SyncOutlined  spin style={{color:'var(--main-color)',fontSize: '24px'}}/>
  }